// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: channels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import {
  DisclaimerMessage,
  DisclaimerMessageUpdateDisclaimerMessage,
  Greeting,
  GreetingUpdateGreeting,
} from "./agent_settings";
import { Asr } from "./asr";
import { ASRSettings, ASRSettingsUpdateASRSettings } from "./asr_settings";
import { ContentFilterSettings, ContentFilterSettingsUpdateContentFilterSettings } from "./content_filter_settings";
import { Timestamp } from "./google/protobuf/timestamp";
import { LLMSettings, LLMSettingsUpdateLLMSettings } from "./llm_settings";

export const protobufPackage = "channels";

export enum ChannelType {
  VOICE = 0,
  WEB_CHAT = 1,
  UNRECOGNIZED = -1,
}

export function channelTypeFromJSON(object: any): ChannelType {
  switch (object) {
    case 0:
    case "VOICE":
      return ChannelType.VOICE;
    case 1:
    case "WEB_CHAT":
      return ChannelType.WEB_CHAT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChannelType.UNRECOGNIZED;
  }
}

export function channelTypeToJSON(object: ChannelType): string {
  switch (object) {
    case ChannelType.VOICE:
      return "VOICE";
    case ChannelType.WEB_CHAT:
      return "WEB_CHAT";
    case ChannelType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ChannelStatus {
  /** NOT_CREATED - Default */
  NOT_CREATED = 0,
  CREATED = 1,
  UNRECOGNIZED = -1,
}

export function channelStatusFromJSON(object: any): ChannelStatus {
  switch (object) {
    case 0:
    case "NOT_CREATED":
      return ChannelStatus.NOT_CREATED;
    case 1:
    case "CREATED":
      return ChannelStatus.CREATED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChannelStatus.UNRECOGNIZED;
  }
}

export function channelStatusToJSON(object: ChannelStatus): string {
  switch (object) {
    case ChannelStatus.NOT_CREATED:
      return "NOT_CREATED";
    case ChannelStatus.CREATED:
      return "CREATED";
    case ChannelStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StylePrompt {
  prompt: string;
  createdAt: string;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
}

export interface StylePromptUpdateStylePrompt {
  prompt: string;
}

export interface ChannelConfig {
  llmSettings: LLMSettings | undefined;
  stylePrompt: StylePrompt | undefined;
  greeting: Greeting | undefined;
  safetyFilters: ContentFilterSettings | undefined;
  temperature?: number | undefined;
}

export interface VADConfig {
  speechEndWindowSeconds: number;
}

export interface BargeInConfig {
  enabled?: boolean | undefined;
  allowedFirstTurn?: boolean | undefined;
  maxPerCall?: number | undefined;
  minSpeechDurationSeconds?: number | undefined;
}

export interface FillerUtterances {
  enabled: boolean;
  utterances: FillerUtterances_Utterance[];
  randomize: boolean;
  initialIntervalSeconds: number;
  intervalSeconds: number;
}

export interface FillerUtterances_Utterance {
  message: string;
}

export interface AICousticsEnhancement {
  enabled: boolean;
  modelQualityTier: AICousticsEnhancement_QualityTier;
  noiseReduction: number;
  voiceGain: number;
  noiseGate: boolean;
}

export enum AICousticsEnhancement_QualityTier {
  QUALITY_TIER_UNSPECIFIED = 0,
  QUALITY_TIER_STANDARD = 1,
  QUALITY_TIER_HIGH = 2,
  QUALITY_TIER_FAST = 3,
  UNRECOGNIZED = -1,
}

export function aICousticsEnhancement_QualityTierFromJSON(object: any): AICousticsEnhancement_QualityTier {
  switch (object) {
    case 0:
    case "QUALITY_TIER_UNSPECIFIED":
      return AICousticsEnhancement_QualityTier.QUALITY_TIER_UNSPECIFIED;
    case 1:
    case "QUALITY_TIER_STANDARD":
      return AICousticsEnhancement_QualityTier.QUALITY_TIER_STANDARD;
    case 2:
    case "QUALITY_TIER_HIGH":
      return AICousticsEnhancement_QualityTier.QUALITY_TIER_HIGH;
    case 3:
    case "QUALITY_TIER_FAST":
      return AICousticsEnhancement_QualityTier.QUALITY_TIER_FAST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AICousticsEnhancement_QualityTier.UNRECOGNIZED;
  }
}

export function aICousticsEnhancement_QualityTierToJSON(object: AICousticsEnhancement_QualityTier): string {
  switch (object) {
    case AICousticsEnhancement_QualityTier.QUALITY_TIER_UNSPECIFIED:
      return "QUALITY_TIER_UNSPECIFIED";
    case AICousticsEnhancement_QualityTier.QUALITY_TIER_STANDARD:
      return "QUALITY_TIER_STANDARD";
    case AICousticsEnhancement_QualityTier.QUALITY_TIER_HIGH:
      return "QUALITY_TIER_HIGH";
    case AICousticsEnhancement_QualityTier.QUALITY_TIER_FAST:
      return "QUALITY_TIER_FAST";
    case AICousticsEnhancement_QualityTier.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AudioEnhancement {
  provider: { $case: "aiCoustics"; value: AICousticsEnhancement } | undefined;
}

export interface VoiceChannel {
  config: ChannelConfig | undefined;
  asrSettings: ASRSettings | undefined;
  disclaimer: DisclaimerMessage | undefined;
  vadConfig: VADConfig | undefined;
  audioEnhancement: AudioEnhancement | undefined;
  silenceFillerUtterances: FillerUtterances | undefined;
  asrConfig: Asr | undefined;
  bargeInConfig: BargeInConfig | undefined;
}

export interface WebChatChannel {
  config: ChannelConfig | undefined;
  status: ChannelStatus;
}

export interface Channels {
  voice: VoiceChannel | undefined;
  webChat: WebChatChannel | undefined;
}

/** Channel messages (shared) */
export interface ChannelUpdateGreeting {
  channelType: ChannelType;
  greeting: GreetingUpdateGreeting | undefined;
}

export interface ChannelUpdateStylePrompt {
  channelType: ChannelType;
  stylePrompt: StylePromptUpdateStylePrompt | undefined;
}

export interface ChannelUpdateSafetyFilters {
  channelType: ChannelType;
  safetyFilters: ContentFilterSettingsUpdateContentFilterSettings | undefined;
}

export interface ChannelUpdateLLMSettings {
  channelType: ChannelType;
  llmSettings: LLMSettingsUpdateLLMSettings | undefined;
}

export interface ChannelUpdateStatus {
  channelStatus: { $case: "webchat"; value: WebChatChannelUpdateStatus } | undefined;
}

/** VoiceChannel messages */
export interface VoiceChannelUpdateASRSettings {
  asrSettings: ASRSettingsUpdateASRSettings | undefined;
}

export interface VoiceChannelUpdateDisclaimer {
  disclaimer: DisclaimerMessageUpdateDisclaimerMessage | undefined;
}

export interface VoiceChannelUpdateVadConfig {
  vadConfig: VADConfig | undefined;
}

export interface VoiceChannelResetVadConfig {
}

export interface VoiceChannelUpdateAudioEnhancement {
  audioEnhancement: AudioEnhancement | undefined;
}

export interface VoiceChannelResetAudioEnhancement {
}

export interface VoiceChannelUpdateSilenceFillerUtterances {
  silenceFillerUtterances: FillerUtterances | undefined;
}

export interface VoiceChannelResetSilenceFillerUtterances {
}

export interface VoiceChannelUpdateAsrConfig {
  asrConfig: Asr | undefined;
}

export interface VoiceChannelResetAsrConfig {
}

export interface VoiceChannelUpdateBargeInConfig {
  enabled?: boolean | undefined;
  allowedFirstTurn?: boolean | undefined;
  maxPerCall?: number | undefined;
  minSpeechDurationSeconds?: number | undefined;
}

export interface VoiceChannelResetBargeInConfig {
}

export interface VoiceChannelUpdateTemperature {
  temperature?: number | undefined;
}

export interface VoiceChannelResetTemperature {
}

/** WebChatChannel messages */
export interface WebChatChannelUpdateStatus {
  status: ChannelStatus;
}

function createBaseStylePrompt(): StylePrompt {
  return { prompt: "", createdAt: "", createdBy: "", updatedAt: undefined, updatedBy: undefined };
}

export const StylePrompt: MessageFns<StylePrompt> = {
  encode(message: StylePrompt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prompt !== "") {
      writer.uint32(10).string(message.prompt);
    }
    if (message.createdAt !== "") {
      writer.uint32(18).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(42).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StylePrompt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStylePrompt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StylePrompt {
    return {
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
    };
  },

  toJSON(message: StylePrompt): unknown {
    const obj: any = {};
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<StylePrompt>): StylePrompt {
    return StylePrompt.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StylePrompt>): StylePrompt {
    const message = createBaseStylePrompt();
    message.prompt = object.prompt ?? "";
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    return message;
  },
};

function createBaseStylePromptUpdateStylePrompt(): StylePromptUpdateStylePrompt {
  return { prompt: "" };
}

export const StylePromptUpdateStylePrompt: MessageFns<StylePromptUpdateStylePrompt> = {
  encode(message: StylePromptUpdateStylePrompt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prompt !== "") {
      writer.uint32(10).string(message.prompt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StylePromptUpdateStylePrompt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStylePromptUpdateStylePrompt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StylePromptUpdateStylePrompt {
    return { prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "" };
  },

  toJSON(message: StylePromptUpdateStylePrompt): unknown {
    const obj: any = {};
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    return obj;
  },

  create(base?: DeepPartial<StylePromptUpdateStylePrompt>): StylePromptUpdateStylePrompt {
    return StylePromptUpdateStylePrompt.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StylePromptUpdateStylePrompt>): StylePromptUpdateStylePrompt {
    const message = createBaseStylePromptUpdateStylePrompt();
    message.prompt = object.prompt ?? "";
    return message;
  },
};

function createBaseChannelConfig(): ChannelConfig {
  return {
    llmSettings: undefined,
    stylePrompt: undefined,
    greeting: undefined,
    safetyFilters: undefined,
    temperature: undefined,
  };
}

export const ChannelConfig: MessageFns<ChannelConfig> = {
  encode(message: ChannelConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.llmSettings !== undefined) {
      LLMSettings.encode(message.llmSettings, writer.uint32(10).fork()).join();
    }
    if (message.stylePrompt !== undefined) {
      StylePrompt.encode(message.stylePrompt, writer.uint32(18).fork()).join();
    }
    if (message.greeting !== undefined) {
      Greeting.encode(message.greeting, writer.uint32(26).fork()).join();
    }
    if (message.safetyFilters !== undefined) {
      ContentFilterSettings.encode(message.safetyFilters, writer.uint32(34).fork()).join();
    }
    if (message.temperature !== undefined) {
      writer.uint32(45).float(message.temperature);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.llmSettings = LLMSettings.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stylePrompt = StylePrompt.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.greeting = Greeting.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.safetyFilters = ContentFilterSettings.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelConfig {
    return {
      llmSettings: isSet(object.llmSettings)
        ? LLMSettings.fromJSON(object.llmSettings)
        : isSet(object.llm_settings)
        ? LLMSettings.fromJSON(object.llm_settings)
        : undefined,
      stylePrompt: isSet(object.stylePrompt)
        ? StylePrompt.fromJSON(object.stylePrompt)
        : isSet(object.style_prompt)
        ? StylePrompt.fromJSON(object.style_prompt)
        : undefined,
      greeting: isSet(object.greeting) ? Greeting.fromJSON(object.greeting) : undefined,
      safetyFilters: isSet(object.safetyFilters)
        ? ContentFilterSettings.fromJSON(object.safetyFilters)
        : isSet(object.safety_filters)
        ? ContentFilterSettings.fromJSON(object.safety_filters)
        : undefined,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : undefined,
    };
  },

  toJSON(message: ChannelConfig): unknown {
    const obj: any = {};
    if (message.llmSettings !== undefined) {
      obj.llmSettings = LLMSettings.toJSON(message.llmSettings);
    }
    if (message.stylePrompt !== undefined) {
      obj.stylePrompt = StylePrompt.toJSON(message.stylePrompt);
    }
    if (message.greeting !== undefined) {
      obj.greeting = Greeting.toJSON(message.greeting);
    }
    if (message.safetyFilters !== undefined) {
      obj.safetyFilters = ContentFilterSettings.toJSON(message.safetyFilters);
    }
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create(base?: DeepPartial<ChannelConfig>): ChannelConfig {
    return ChannelConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChannelConfig>): ChannelConfig {
    const message = createBaseChannelConfig();
    message.llmSettings = (object.llmSettings !== undefined && object.llmSettings !== null)
      ? LLMSettings.fromPartial(object.llmSettings)
      : undefined;
    message.stylePrompt = (object.stylePrompt !== undefined && object.stylePrompt !== null)
      ? StylePrompt.fromPartial(object.stylePrompt)
      : undefined;
    message.greeting = (object.greeting !== undefined && object.greeting !== null)
      ? Greeting.fromPartial(object.greeting)
      : undefined;
    message.safetyFilters = (object.safetyFilters !== undefined && object.safetyFilters !== null)
      ? ContentFilterSettings.fromPartial(object.safetyFilters)
      : undefined;
    message.temperature = object.temperature ?? undefined;
    return message;
  },
};

function createBaseVADConfig(): VADConfig {
  return { speechEndWindowSeconds: 0 };
}

export const VADConfig: MessageFns<VADConfig> = {
  encode(message: VADConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.speechEndWindowSeconds !== 0) {
      writer.uint32(9).double(message.speechEndWindowSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VADConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVADConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.speechEndWindowSeconds = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VADConfig {
    return {
      speechEndWindowSeconds: isSet(object.speechEndWindowSeconds)
        ? globalThis.Number(object.speechEndWindowSeconds)
        : isSet(object.speech_end_window_seconds)
        ? globalThis.Number(object.speech_end_window_seconds)
        : 0,
    };
  },

  toJSON(message: VADConfig): unknown {
    const obj: any = {};
    if (message.speechEndWindowSeconds !== 0) {
      obj.speechEndWindowSeconds = message.speechEndWindowSeconds;
    }
    return obj;
  },

  create(base?: DeepPartial<VADConfig>): VADConfig {
    return VADConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VADConfig>): VADConfig {
    const message = createBaseVADConfig();
    message.speechEndWindowSeconds = object.speechEndWindowSeconds ?? 0;
    return message;
  },
};

function createBaseBargeInConfig(): BargeInConfig {
  return {
    enabled: undefined,
    allowedFirstTurn: undefined,
    maxPerCall: undefined,
    minSpeechDurationSeconds: undefined,
  };
}

export const BargeInConfig: MessageFns<BargeInConfig> = {
  encode(message: BargeInConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== undefined) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.allowedFirstTurn !== undefined) {
      writer.uint32(16).bool(message.allowedFirstTurn);
    }
    if (message.maxPerCall !== undefined) {
      writer.uint32(24).int32(message.maxPerCall);
    }
    if (message.minSpeechDurationSeconds !== undefined) {
      writer.uint32(33).double(message.minSpeechDurationSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BargeInConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBargeInConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.allowedFirstTurn = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxPerCall = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.minSpeechDurationSeconds = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BargeInConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      allowedFirstTurn: isSet(object.allowedFirstTurn)
        ? globalThis.Boolean(object.allowedFirstTurn)
        : isSet(object.allowed_first_turn)
        ? globalThis.Boolean(object.allowed_first_turn)
        : undefined,
      maxPerCall: isSet(object.maxPerCall)
        ? globalThis.Number(object.maxPerCall)
        : isSet(object.max_per_call)
        ? globalThis.Number(object.max_per_call)
        : undefined,
      minSpeechDurationSeconds: isSet(object.minSpeechDurationSeconds)
        ? globalThis.Number(object.minSpeechDurationSeconds)
        : isSet(object.min_speech_duration_seconds)
        ? globalThis.Number(object.min_speech_duration_seconds)
        : undefined,
    };
  },

  toJSON(message: BargeInConfig): unknown {
    const obj: any = {};
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.allowedFirstTurn !== undefined) {
      obj.allowedFirstTurn = message.allowedFirstTurn;
    }
    if (message.maxPerCall !== undefined) {
      obj.maxPerCall = Math.round(message.maxPerCall);
    }
    if (message.minSpeechDurationSeconds !== undefined) {
      obj.minSpeechDurationSeconds = message.minSpeechDurationSeconds;
    }
    return obj;
  },

  create(base?: DeepPartial<BargeInConfig>): BargeInConfig {
    return BargeInConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BargeInConfig>): BargeInConfig {
    const message = createBaseBargeInConfig();
    message.enabled = object.enabled ?? undefined;
    message.allowedFirstTurn = object.allowedFirstTurn ?? undefined;
    message.maxPerCall = object.maxPerCall ?? undefined;
    message.minSpeechDurationSeconds = object.minSpeechDurationSeconds ?? undefined;
    return message;
  },
};

function createBaseFillerUtterances(): FillerUtterances {
  return { enabled: false, utterances: [], randomize: false, initialIntervalSeconds: 0, intervalSeconds: 0 };
}

export const FillerUtterances: MessageFns<FillerUtterances> = {
  encode(message: FillerUtterances, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    for (const v of message.utterances) {
      FillerUtterances_Utterance.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.randomize !== false) {
      writer.uint32(40).bool(message.randomize);
    }
    if (message.initialIntervalSeconds !== 0) {
      writer.uint32(49).double(message.initialIntervalSeconds);
    }
    if (message.intervalSeconds !== 0) {
      writer.uint32(57).double(message.intervalSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FillerUtterances {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFillerUtterances();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.utterances.push(FillerUtterances_Utterance.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.randomize = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.initialIntervalSeconds = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.intervalSeconds = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FillerUtterances {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      utterances: globalThis.Array.isArray(object?.utterances)
        ? object.utterances.map((e: any) => FillerUtterances_Utterance.fromJSON(e))
        : [],
      randomize: isSet(object.randomize) ? globalThis.Boolean(object.randomize) : false,
      initialIntervalSeconds: isSet(object.initialIntervalSeconds)
        ? globalThis.Number(object.initialIntervalSeconds)
        : isSet(object.initial_interval_seconds)
        ? globalThis.Number(object.initial_interval_seconds)
        : 0,
      intervalSeconds: isSet(object.intervalSeconds)
        ? globalThis.Number(object.intervalSeconds)
        : isSet(object.interval_seconds)
        ? globalThis.Number(object.interval_seconds)
        : 0,
    };
  },

  toJSON(message: FillerUtterances): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.utterances?.length) {
      obj.utterances = message.utterances.map((e) => FillerUtterances_Utterance.toJSON(e));
    }
    if (message.randomize !== false) {
      obj.randomize = message.randomize;
    }
    if (message.initialIntervalSeconds !== 0) {
      obj.initialIntervalSeconds = message.initialIntervalSeconds;
    }
    if (message.intervalSeconds !== 0) {
      obj.intervalSeconds = message.intervalSeconds;
    }
    return obj;
  },

  create(base?: DeepPartial<FillerUtterances>): FillerUtterances {
    return FillerUtterances.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FillerUtterances>): FillerUtterances {
    const message = createBaseFillerUtterances();
    message.enabled = object.enabled ?? false;
    message.utterances = object.utterances?.map((e) => FillerUtterances_Utterance.fromPartial(e)) || [];
    message.randomize = object.randomize ?? false;
    message.initialIntervalSeconds = object.initialIntervalSeconds ?? 0;
    message.intervalSeconds = object.intervalSeconds ?? 0;
    return message;
  },
};

function createBaseFillerUtterances_Utterance(): FillerUtterances_Utterance {
  return { message: "" };
}

export const FillerUtterances_Utterance: MessageFns<FillerUtterances_Utterance> = {
  encode(message: FillerUtterances_Utterance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FillerUtterances_Utterance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFillerUtterances_Utterance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FillerUtterances_Utterance {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: FillerUtterances_Utterance): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create(base?: DeepPartial<FillerUtterances_Utterance>): FillerUtterances_Utterance {
    return FillerUtterances_Utterance.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FillerUtterances_Utterance>): FillerUtterances_Utterance {
    const message = createBaseFillerUtterances_Utterance();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseAICousticsEnhancement(): AICousticsEnhancement {
  return { enabled: false, modelQualityTier: 0, noiseReduction: 0, voiceGain: 0, noiseGate: false };
}

export const AICousticsEnhancement: MessageFns<AICousticsEnhancement> = {
  encode(message: AICousticsEnhancement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.modelQualityTier !== 0) {
      writer.uint32(16).int32(message.modelQualityTier);
    }
    if (message.noiseReduction !== 0) {
      writer.uint32(29).float(message.noiseReduction);
    }
    if (message.voiceGain !== 0) {
      writer.uint32(37).float(message.voiceGain);
    }
    if (message.noiseGate !== false) {
      writer.uint32(40).bool(message.noiseGate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AICousticsEnhancement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAICousticsEnhancement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.modelQualityTier = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.noiseReduction = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.voiceGain = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.noiseGate = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AICousticsEnhancement {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      modelQualityTier: isSet(object.modelQualityTier)
        ? aICousticsEnhancement_QualityTierFromJSON(object.modelQualityTier)
        : isSet(object.model_quality_tier)
        ? aICousticsEnhancement_QualityTierFromJSON(object.model_quality_tier)
        : 0,
      noiseReduction: isSet(object.noiseReduction)
        ? globalThis.Number(object.noiseReduction)
        : isSet(object.noise_reduction)
        ? globalThis.Number(object.noise_reduction)
        : 0,
      voiceGain: isSet(object.voiceGain)
        ? globalThis.Number(object.voiceGain)
        : isSet(object.voice_gain)
        ? globalThis.Number(object.voice_gain)
        : 0,
      noiseGate: isSet(object.noiseGate)
        ? globalThis.Boolean(object.noiseGate)
        : isSet(object.noise_gate)
        ? globalThis.Boolean(object.noise_gate)
        : false,
    };
  },

  toJSON(message: AICousticsEnhancement): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.modelQualityTier !== 0) {
      obj.modelQualityTier = aICousticsEnhancement_QualityTierToJSON(message.modelQualityTier);
    }
    if (message.noiseReduction !== 0) {
      obj.noiseReduction = message.noiseReduction;
    }
    if (message.voiceGain !== 0) {
      obj.voiceGain = message.voiceGain;
    }
    if (message.noiseGate !== false) {
      obj.noiseGate = message.noiseGate;
    }
    return obj;
  },

  create(base?: DeepPartial<AICousticsEnhancement>): AICousticsEnhancement {
    return AICousticsEnhancement.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AICousticsEnhancement>): AICousticsEnhancement {
    const message = createBaseAICousticsEnhancement();
    message.enabled = object.enabled ?? false;
    message.modelQualityTier = object.modelQualityTier ?? 0;
    message.noiseReduction = object.noiseReduction ?? 0;
    message.voiceGain = object.voiceGain ?? 0;
    message.noiseGate = object.noiseGate ?? false;
    return message;
  },
};

function createBaseAudioEnhancement(): AudioEnhancement {
  return { provider: undefined };
}

export const AudioEnhancement: MessageFns<AudioEnhancement> = {
  encode(message: AudioEnhancement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.provider?.$case) {
      case "aiCoustics":
        AICousticsEnhancement.encode(message.provider.value, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AudioEnhancement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAudioEnhancement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = { $case: "aiCoustics", value: AICousticsEnhancement.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AudioEnhancement {
    return {
      provider: isSet(object.aiCoustics)
        ? { $case: "aiCoustics", value: AICousticsEnhancement.fromJSON(object.aiCoustics) }
        : isSet(object.ai_coustics)
        ? { $case: "aiCoustics", value: AICousticsEnhancement.fromJSON(object.ai_coustics) }
        : undefined,
    };
  },

  toJSON(message: AudioEnhancement): unknown {
    const obj: any = {};
    if (message.provider?.$case === "aiCoustics") {
      obj.aiCoustics = AICousticsEnhancement.toJSON(message.provider.value);
    }
    return obj;
  },

  create(base?: DeepPartial<AudioEnhancement>): AudioEnhancement {
    return AudioEnhancement.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AudioEnhancement>): AudioEnhancement {
    const message = createBaseAudioEnhancement();
    switch (object.provider?.$case) {
      case "aiCoustics": {
        if (object.provider?.value !== undefined && object.provider?.value !== null) {
          message.provider = { $case: "aiCoustics", value: AICousticsEnhancement.fromPartial(object.provider.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVoiceChannel(): VoiceChannel {
  return {
    config: undefined,
    asrSettings: undefined,
    disclaimer: undefined,
    vadConfig: undefined,
    audioEnhancement: undefined,
    silenceFillerUtterances: undefined,
    asrConfig: undefined,
    bargeInConfig: undefined,
  };
}

export const VoiceChannel: MessageFns<VoiceChannel> = {
  encode(message: VoiceChannel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      ChannelConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.asrSettings !== undefined) {
      ASRSettings.encode(message.asrSettings, writer.uint32(18).fork()).join();
    }
    if (message.disclaimer !== undefined) {
      DisclaimerMessage.encode(message.disclaimer, writer.uint32(26).fork()).join();
    }
    if (message.vadConfig !== undefined) {
      VADConfig.encode(message.vadConfig, writer.uint32(34).fork()).join();
    }
    if (message.audioEnhancement !== undefined) {
      AudioEnhancement.encode(message.audioEnhancement, writer.uint32(42).fork()).join();
    }
    if (message.silenceFillerUtterances !== undefined) {
      FillerUtterances.encode(message.silenceFillerUtterances, writer.uint32(50).fork()).join();
    }
    if (message.asrConfig !== undefined) {
      Asr.encode(message.asrConfig, writer.uint32(58).fork()).join();
    }
    if (message.bargeInConfig !== undefined) {
      BargeInConfig.encode(message.bargeInConfig, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = ChannelConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.asrSettings = ASRSettings.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.disclaimer = DisclaimerMessage.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vadConfig = VADConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.audioEnhancement = AudioEnhancement.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.silenceFillerUtterances = FillerUtterances.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.asrConfig = Asr.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.bargeInConfig = BargeInConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannel {
    return {
      config: isSet(object.config) ? ChannelConfig.fromJSON(object.config) : undefined,
      asrSettings: isSet(object.asrSettings)
        ? ASRSettings.fromJSON(object.asrSettings)
        : isSet(object.asr_settings)
        ? ASRSettings.fromJSON(object.asr_settings)
        : undefined,
      disclaimer: isSet(object.disclaimer) ? DisclaimerMessage.fromJSON(object.disclaimer) : undefined,
      vadConfig: isSet(object.vadConfig)
        ? VADConfig.fromJSON(object.vadConfig)
        : isSet(object.vad_config)
        ? VADConfig.fromJSON(object.vad_config)
        : undefined,
      audioEnhancement: isSet(object.audioEnhancement)
        ? AudioEnhancement.fromJSON(object.audioEnhancement)
        : isSet(object.audio_enhancement)
        ? AudioEnhancement.fromJSON(object.audio_enhancement)
        : undefined,
      silenceFillerUtterances: isSet(object.silenceFillerUtterances)
        ? FillerUtterances.fromJSON(object.silenceFillerUtterances)
        : isSet(object.silence_filler_utterances)
        ? FillerUtterances.fromJSON(object.silence_filler_utterances)
        : undefined,
      asrConfig: isSet(object.asrConfig)
        ? Asr.fromJSON(object.asrConfig)
        : isSet(object.asr_config)
        ? Asr.fromJSON(object.asr_config)
        : undefined,
      bargeInConfig: isSet(object.bargeInConfig)
        ? BargeInConfig.fromJSON(object.bargeInConfig)
        : isSet(object.barge_in_config)
        ? BargeInConfig.fromJSON(object.barge_in_config)
        : undefined,
    };
  },

  toJSON(message: VoiceChannel): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = ChannelConfig.toJSON(message.config);
    }
    if (message.asrSettings !== undefined) {
      obj.asrSettings = ASRSettings.toJSON(message.asrSettings);
    }
    if (message.disclaimer !== undefined) {
      obj.disclaimer = DisclaimerMessage.toJSON(message.disclaimer);
    }
    if (message.vadConfig !== undefined) {
      obj.vadConfig = VADConfig.toJSON(message.vadConfig);
    }
    if (message.audioEnhancement !== undefined) {
      obj.audioEnhancement = AudioEnhancement.toJSON(message.audioEnhancement);
    }
    if (message.silenceFillerUtterances !== undefined) {
      obj.silenceFillerUtterances = FillerUtterances.toJSON(message.silenceFillerUtterances);
    }
    if (message.asrConfig !== undefined) {
      obj.asrConfig = Asr.toJSON(message.asrConfig);
    }
    if (message.bargeInConfig !== undefined) {
      obj.bargeInConfig = BargeInConfig.toJSON(message.bargeInConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannel>): VoiceChannel {
    return VoiceChannel.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannel>): VoiceChannel {
    const message = createBaseVoiceChannel();
    message.config = (object.config !== undefined && object.config !== null)
      ? ChannelConfig.fromPartial(object.config)
      : undefined;
    message.asrSettings = (object.asrSettings !== undefined && object.asrSettings !== null)
      ? ASRSettings.fromPartial(object.asrSettings)
      : undefined;
    message.disclaimer = (object.disclaimer !== undefined && object.disclaimer !== null)
      ? DisclaimerMessage.fromPartial(object.disclaimer)
      : undefined;
    message.vadConfig = (object.vadConfig !== undefined && object.vadConfig !== null)
      ? VADConfig.fromPartial(object.vadConfig)
      : undefined;
    message.audioEnhancement = (object.audioEnhancement !== undefined && object.audioEnhancement !== null)
      ? AudioEnhancement.fromPartial(object.audioEnhancement)
      : undefined;
    message.silenceFillerUtterances =
      (object.silenceFillerUtterances !== undefined && object.silenceFillerUtterances !== null)
        ? FillerUtterances.fromPartial(object.silenceFillerUtterances)
        : undefined;
    message.asrConfig = (object.asrConfig !== undefined && object.asrConfig !== null)
      ? Asr.fromPartial(object.asrConfig)
      : undefined;
    message.bargeInConfig = (object.bargeInConfig !== undefined && object.bargeInConfig !== null)
      ? BargeInConfig.fromPartial(object.bargeInConfig)
      : undefined;
    return message;
  },
};

function createBaseWebChatChannel(): WebChatChannel {
  return { config: undefined, status: 0 };
}

export const WebChatChannel: MessageFns<WebChatChannel> = {
  encode(message: WebChatChannel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      ChannelConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebChatChannel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebChatChannel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = ChannelConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebChatChannel {
    return {
      config: isSet(object.config) ? ChannelConfig.fromJSON(object.config) : undefined,
      status: isSet(object.status) ? channelStatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: WebChatChannel): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = ChannelConfig.toJSON(message.config);
    }
    if (message.status !== 0) {
      obj.status = channelStatusToJSON(message.status);
    }
    return obj;
  },

  create(base?: DeepPartial<WebChatChannel>): WebChatChannel {
    return WebChatChannel.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WebChatChannel>): WebChatChannel {
    const message = createBaseWebChatChannel();
    message.config = (object.config !== undefined && object.config !== null)
      ? ChannelConfig.fromPartial(object.config)
      : undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseChannels(): Channels {
  return { voice: undefined, webChat: undefined };
}

export const Channels: MessageFns<Channels> = {
  encode(message: Channels, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voice !== undefined) {
      VoiceChannel.encode(message.voice, writer.uint32(10).fork()).join();
    }
    if (message.webChat !== undefined) {
      WebChatChannel.encode(message.webChat, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Channels {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannels();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voice = VoiceChannel.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.webChat = WebChatChannel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Channels {
    return {
      voice: isSet(object.voice) ? VoiceChannel.fromJSON(object.voice) : undefined,
      webChat: isSet(object.webChat)
        ? WebChatChannel.fromJSON(object.webChat)
        : isSet(object.web_chat)
        ? WebChatChannel.fromJSON(object.web_chat)
        : undefined,
    };
  },

  toJSON(message: Channels): unknown {
    const obj: any = {};
    if (message.voice !== undefined) {
      obj.voice = VoiceChannel.toJSON(message.voice);
    }
    if (message.webChat !== undefined) {
      obj.webChat = WebChatChannel.toJSON(message.webChat);
    }
    return obj;
  },

  create(base?: DeepPartial<Channels>): Channels {
    return Channels.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Channels>): Channels {
    const message = createBaseChannels();
    message.voice = (object.voice !== undefined && object.voice !== null)
      ? VoiceChannel.fromPartial(object.voice)
      : undefined;
    message.webChat = (object.webChat !== undefined && object.webChat !== null)
      ? WebChatChannel.fromPartial(object.webChat)
      : undefined;
    return message;
  },
};

function createBaseChannelUpdateGreeting(): ChannelUpdateGreeting {
  return { channelType: 0, greeting: undefined };
}

export const ChannelUpdateGreeting: MessageFns<ChannelUpdateGreeting> = {
  encode(message: ChannelUpdateGreeting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelType !== 0) {
      writer.uint32(8).int32(message.channelType);
    }
    if (message.greeting !== undefined) {
      GreetingUpdateGreeting.encode(message.greeting, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelUpdateGreeting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelUpdateGreeting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channelType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.greeting = GreetingUpdateGreeting.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelUpdateGreeting {
    return {
      channelType: isSet(object.channelType)
        ? channelTypeFromJSON(object.channelType)
        : isSet(object.channel_type)
        ? channelTypeFromJSON(object.channel_type)
        : 0,
      greeting: isSet(object.greeting) ? GreetingUpdateGreeting.fromJSON(object.greeting) : undefined,
    };
  },

  toJSON(message: ChannelUpdateGreeting): unknown {
    const obj: any = {};
    if (message.channelType !== 0) {
      obj.channelType = channelTypeToJSON(message.channelType);
    }
    if (message.greeting !== undefined) {
      obj.greeting = GreetingUpdateGreeting.toJSON(message.greeting);
    }
    return obj;
  },

  create(base?: DeepPartial<ChannelUpdateGreeting>): ChannelUpdateGreeting {
    return ChannelUpdateGreeting.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChannelUpdateGreeting>): ChannelUpdateGreeting {
    const message = createBaseChannelUpdateGreeting();
    message.channelType = object.channelType ?? 0;
    message.greeting = (object.greeting !== undefined && object.greeting !== null)
      ? GreetingUpdateGreeting.fromPartial(object.greeting)
      : undefined;
    return message;
  },
};

function createBaseChannelUpdateStylePrompt(): ChannelUpdateStylePrompt {
  return { channelType: 0, stylePrompt: undefined };
}

export const ChannelUpdateStylePrompt: MessageFns<ChannelUpdateStylePrompt> = {
  encode(message: ChannelUpdateStylePrompt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelType !== 0) {
      writer.uint32(8).int32(message.channelType);
    }
    if (message.stylePrompt !== undefined) {
      StylePromptUpdateStylePrompt.encode(message.stylePrompt, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelUpdateStylePrompt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelUpdateStylePrompt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channelType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stylePrompt = StylePromptUpdateStylePrompt.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelUpdateStylePrompt {
    return {
      channelType: isSet(object.channelType)
        ? channelTypeFromJSON(object.channelType)
        : isSet(object.channel_type)
        ? channelTypeFromJSON(object.channel_type)
        : 0,
      stylePrompt: isSet(object.stylePrompt)
        ? StylePromptUpdateStylePrompt.fromJSON(object.stylePrompt)
        : isSet(object.style_prompt)
        ? StylePromptUpdateStylePrompt.fromJSON(object.style_prompt)
        : undefined,
    };
  },

  toJSON(message: ChannelUpdateStylePrompt): unknown {
    const obj: any = {};
    if (message.channelType !== 0) {
      obj.channelType = channelTypeToJSON(message.channelType);
    }
    if (message.stylePrompt !== undefined) {
      obj.stylePrompt = StylePromptUpdateStylePrompt.toJSON(message.stylePrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<ChannelUpdateStylePrompt>): ChannelUpdateStylePrompt {
    return ChannelUpdateStylePrompt.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChannelUpdateStylePrompt>): ChannelUpdateStylePrompt {
    const message = createBaseChannelUpdateStylePrompt();
    message.channelType = object.channelType ?? 0;
    message.stylePrompt = (object.stylePrompt !== undefined && object.stylePrompt !== null)
      ? StylePromptUpdateStylePrompt.fromPartial(object.stylePrompt)
      : undefined;
    return message;
  },
};

function createBaseChannelUpdateSafetyFilters(): ChannelUpdateSafetyFilters {
  return { channelType: 0, safetyFilters: undefined };
}

export const ChannelUpdateSafetyFilters: MessageFns<ChannelUpdateSafetyFilters> = {
  encode(message: ChannelUpdateSafetyFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelType !== 0) {
      writer.uint32(8).int32(message.channelType);
    }
    if (message.safetyFilters !== undefined) {
      ContentFilterSettingsUpdateContentFilterSettings.encode(message.safetyFilters, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelUpdateSafetyFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelUpdateSafetyFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channelType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.safetyFilters = ContentFilterSettingsUpdateContentFilterSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelUpdateSafetyFilters {
    return {
      channelType: isSet(object.channelType)
        ? channelTypeFromJSON(object.channelType)
        : isSet(object.channel_type)
        ? channelTypeFromJSON(object.channel_type)
        : 0,
      safetyFilters: isSet(object.safetyFilters)
        ? ContentFilterSettingsUpdateContentFilterSettings.fromJSON(object.safetyFilters)
        : isSet(object.safety_filters)
        ? ContentFilterSettingsUpdateContentFilterSettings.fromJSON(object.safety_filters)
        : undefined,
    };
  },

  toJSON(message: ChannelUpdateSafetyFilters): unknown {
    const obj: any = {};
    if (message.channelType !== 0) {
      obj.channelType = channelTypeToJSON(message.channelType);
    }
    if (message.safetyFilters !== undefined) {
      obj.safetyFilters = ContentFilterSettingsUpdateContentFilterSettings.toJSON(message.safetyFilters);
    }
    return obj;
  },

  create(base?: DeepPartial<ChannelUpdateSafetyFilters>): ChannelUpdateSafetyFilters {
    return ChannelUpdateSafetyFilters.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChannelUpdateSafetyFilters>): ChannelUpdateSafetyFilters {
    const message = createBaseChannelUpdateSafetyFilters();
    message.channelType = object.channelType ?? 0;
    message.safetyFilters = (object.safetyFilters !== undefined && object.safetyFilters !== null)
      ? ContentFilterSettingsUpdateContentFilterSettings.fromPartial(object.safetyFilters)
      : undefined;
    return message;
  },
};

function createBaseChannelUpdateLLMSettings(): ChannelUpdateLLMSettings {
  return { channelType: 0, llmSettings: undefined };
}

export const ChannelUpdateLLMSettings: MessageFns<ChannelUpdateLLMSettings> = {
  encode(message: ChannelUpdateLLMSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelType !== 0) {
      writer.uint32(8).int32(message.channelType);
    }
    if (message.llmSettings !== undefined) {
      LLMSettingsUpdateLLMSettings.encode(message.llmSettings, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelUpdateLLMSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelUpdateLLMSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channelType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.llmSettings = LLMSettingsUpdateLLMSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelUpdateLLMSettings {
    return {
      channelType: isSet(object.channelType)
        ? channelTypeFromJSON(object.channelType)
        : isSet(object.channel_type)
        ? channelTypeFromJSON(object.channel_type)
        : 0,
      llmSettings: isSet(object.llmSettings)
        ? LLMSettingsUpdateLLMSettings.fromJSON(object.llmSettings)
        : isSet(object.llm_settings)
        ? LLMSettingsUpdateLLMSettings.fromJSON(object.llm_settings)
        : undefined,
    };
  },

  toJSON(message: ChannelUpdateLLMSettings): unknown {
    const obj: any = {};
    if (message.channelType !== 0) {
      obj.channelType = channelTypeToJSON(message.channelType);
    }
    if (message.llmSettings !== undefined) {
      obj.llmSettings = LLMSettingsUpdateLLMSettings.toJSON(message.llmSettings);
    }
    return obj;
  },

  create(base?: DeepPartial<ChannelUpdateLLMSettings>): ChannelUpdateLLMSettings {
    return ChannelUpdateLLMSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChannelUpdateLLMSettings>): ChannelUpdateLLMSettings {
    const message = createBaseChannelUpdateLLMSettings();
    message.channelType = object.channelType ?? 0;
    message.llmSettings = (object.llmSettings !== undefined && object.llmSettings !== null)
      ? LLMSettingsUpdateLLMSettings.fromPartial(object.llmSettings)
      : undefined;
    return message;
  },
};

function createBaseChannelUpdateStatus(): ChannelUpdateStatus {
  return { channelStatus: undefined };
}

export const ChannelUpdateStatus: MessageFns<ChannelUpdateStatus> = {
  encode(message: ChannelUpdateStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.channelStatus?.$case) {
      case "webchat":
        WebChatChannelUpdateStatus.encode(message.channelStatus.value, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelUpdateStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelUpdateStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.channelStatus = {
            $case: "webchat",
            value: WebChatChannelUpdateStatus.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelUpdateStatus {
    return {
      channelStatus: isSet(object.webchat)
        ? { $case: "webchat", value: WebChatChannelUpdateStatus.fromJSON(object.webchat) }
        : undefined,
    };
  },

  toJSON(message: ChannelUpdateStatus): unknown {
    const obj: any = {};
    if (message.channelStatus?.$case === "webchat") {
      obj.webchat = WebChatChannelUpdateStatus.toJSON(message.channelStatus.value);
    }
    return obj;
  },

  create(base?: DeepPartial<ChannelUpdateStatus>): ChannelUpdateStatus {
    return ChannelUpdateStatus.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChannelUpdateStatus>): ChannelUpdateStatus {
    const message = createBaseChannelUpdateStatus();
    switch (object.channelStatus?.$case) {
      case "webchat": {
        if (object.channelStatus?.value !== undefined && object.channelStatus?.value !== null) {
          message.channelStatus = {
            $case: "webchat",
            value: WebChatChannelUpdateStatus.fromPartial(object.channelStatus.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVoiceChannelUpdateASRSettings(): VoiceChannelUpdateASRSettings {
  return { asrSettings: undefined };
}

export const VoiceChannelUpdateASRSettings: MessageFns<VoiceChannelUpdateASRSettings> = {
  encode(message: VoiceChannelUpdateASRSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asrSettings !== undefined) {
      ASRSettingsUpdateASRSettings.encode(message.asrSettings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateASRSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateASRSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.asrSettings = ASRSettingsUpdateASRSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateASRSettings {
    return {
      asrSettings: isSet(object.asrSettings)
        ? ASRSettingsUpdateASRSettings.fromJSON(object.asrSettings)
        : isSet(object.asr_settings)
        ? ASRSettingsUpdateASRSettings.fromJSON(object.asr_settings)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateASRSettings): unknown {
    const obj: any = {};
    if (message.asrSettings !== undefined) {
      obj.asrSettings = ASRSettingsUpdateASRSettings.toJSON(message.asrSettings);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateASRSettings>): VoiceChannelUpdateASRSettings {
    return VoiceChannelUpdateASRSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateASRSettings>): VoiceChannelUpdateASRSettings {
    const message = createBaseVoiceChannelUpdateASRSettings();
    message.asrSettings = (object.asrSettings !== undefined && object.asrSettings !== null)
      ? ASRSettingsUpdateASRSettings.fromPartial(object.asrSettings)
      : undefined;
    return message;
  },
};

function createBaseVoiceChannelUpdateDisclaimer(): VoiceChannelUpdateDisclaimer {
  return { disclaimer: undefined };
}

export const VoiceChannelUpdateDisclaimer: MessageFns<VoiceChannelUpdateDisclaimer> = {
  encode(message: VoiceChannelUpdateDisclaimer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.disclaimer !== undefined) {
      DisclaimerMessageUpdateDisclaimerMessage.encode(message.disclaimer, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateDisclaimer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateDisclaimer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.disclaimer = DisclaimerMessageUpdateDisclaimerMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateDisclaimer {
    return {
      disclaimer: isSet(object.disclaimer)
        ? DisclaimerMessageUpdateDisclaimerMessage.fromJSON(object.disclaimer)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateDisclaimer): unknown {
    const obj: any = {};
    if (message.disclaimer !== undefined) {
      obj.disclaimer = DisclaimerMessageUpdateDisclaimerMessage.toJSON(message.disclaimer);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateDisclaimer>): VoiceChannelUpdateDisclaimer {
    return VoiceChannelUpdateDisclaimer.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateDisclaimer>): VoiceChannelUpdateDisclaimer {
    const message = createBaseVoiceChannelUpdateDisclaimer();
    message.disclaimer = (object.disclaimer !== undefined && object.disclaimer !== null)
      ? DisclaimerMessageUpdateDisclaimerMessage.fromPartial(object.disclaimer)
      : undefined;
    return message;
  },
};

function createBaseVoiceChannelUpdateVadConfig(): VoiceChannelUpdateVadConfig {
  return { vadConfig: undefined };
}

export const VoiceChannelUpdateVadConfig: MessageFns<VoiceChannelUpdateVadConfig> = {
  encode(message: VoiceChannelUpdateVadConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vadConfig !== undefined) {
      VADConfig.encode(message.vadConfig, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateVadConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateVadConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vadConfig = VADConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateVadConfig {
    return {
      vadConfig: isSet(object.vadConfig)
        ? VADConfig.fromJSON(object.vadConfig)
        : isSet(object.vad_config)
        ? VADConfig.fromJSON(object.vad_config)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateVadConfig): unknown {
    const obj: any = {};
    if (message.vadConfig !== undefined) {
      obj.vadConfig = VADConfig.toJSON(message.vadConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateVadConfig>): VoiceChannelUpdateVadConfig {
    return VoiceChannelUpdateVadConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateVadConfig>): VoiceChannelUpdateVadConfig {
    const message = createBaseVoiceChannelUpdateVadConfig();
    message.vadConfig = (object.vadConfig !== undefined && object.vadConfig !== null)
      ? VADConfig.fromPartial(object.vadConfig)
      : undefined;
    return message;
  },
};

function createBaseVoiceChannelResetVadConfig(): VoiceChannelResetVadConfig {
  return {};
}

export const VoiceChannelResetVadConfig: MessageFns<VoiceChannelResetVadConfig> = {
  encode(_: VoiceChannelResetVadConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelResetVadConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelResetVadConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VoiceChannelResetVadConfig {
    return {};
  },

  toJSON(_: VoiceChannelResetVadConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelResetVadConfig>): VoiceChannelResetVadConfig {
    return VoiceChannelResetVadConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<VoiceChannelResetVadConfig>): VoiceChannelResetVadConfig {
    const message = createBaseVoiceChannelResetVadConfig();
    return message;
  },
};

function createBaseVoiceChannelUpdateAudioEnhancement(): VoiceChannelUpdateAudioEnhancement {
  return { audioEnhancement: undefined };
}

export const VoiceChannelUpdateAudioEnhancement: MessageFns<VoiceChannelUpdateAudioEnhancement> = {
  encode(message: VoiceChannelUpdateAudioEnhancement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.audioEnhancement !== undefined) {
      AudioEnhancement.encode(message.audioEnhancement, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateAudioEnhancement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateAudioEnhancement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.audioEnhancement = AudioEnhancement.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateAudioEnhancement {
    return {
      audioEnhancement: isSet(object.audioEnhancement)
        ? AudioEnhancement.fromJSON(object.audioEnhancement)
        : isSet(object.audio_enhancement)
        ? AudioEnhancement.fromJSON(object.audio_enhancement)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateAudioEnhancement): unknown {
    const obj: any = {};
    if (message.audioEnhancement !== undefined) {
      obj.audioEnhancement = AudioEnhancement.toJSON(message.audioEnhancement);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateAudioEnhancement>): VoiceChannelUpdateAudioEnhancement {
    return VoiceChannelUpdateAudioEnhancement.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateAudioEnhancement>): VoiceChannelUpdateAudioEnhancement {
    const message = createBaseVoiceChannelUpdateAudioEnhancement();
    message.audioEnhancement = (object.audioEnhancement !== undefined && object.audioEnhancement !== null)
      ? AudioEnhancement.fromPartial(object.audioEnhancement)
      : undefined;
    return message;
  },
};

function createBaseVoiceChannelResetAudioEnhancement(): VoiceChannelResetAudioEnhancement {
  return {};
}

export const VoiceChannelResetAudioEnhancement: MessageFns<VoiceChannelResetAudioEnhancement> = {
  encode(_: VoiceChannelResetAudioEnhancement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelResetAudioEnhancement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelResetAudioEnhancement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VoiceChannelResetAudioEnhancement {
    return {};
  },

  toJSON(_: VoiceChannelResetAudioEnhancement): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelResetAudioEnhancement>): VoiceChannelResetAudioEnhancement {
    return VoiceChannelResetAudioEnhancement.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<VoiceChannelResetAudioEnhancement>): VoiceChannelResetAudioEnhancement {
    const message = createBaseVoiceChannelResetAudioEnhancement();
    return message;
  },
};

function createBaseVoiceChannelUpdateSilenceFillerUtterances(): VoiceChannelUpdateSilenceFillerUtterances {
  return { silenceFillerUtterances: undefined };
}

export const VoiceChannelUpdateSilenceFillerUtterances: MessageFns<VoiceChannelUpdateSilenceFillerUtterances> = {
  encode(message: VoiceChannelUpdateSilenceFillerUtterances, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.silenceFillerUtterances !== undefined) {
      FillerUtterances.encode(message.silenceFillerUtterances, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateSilenceFillerUtterances {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateSilenceFillerUtterances();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.silenceFillerUtterances = FillerUtterances.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateSilenceFillerUtterances {
    return {
      silenceFillerUtterances: isSet(object.silenceFillerUtterances)
        ? FillerUtterances.fromJSON(object.silenceFillerUtterances)
        : isSet(object.silence_filler_utterances)
        ? FillerUtterances.fromJSON(object.silence_filler_utterances)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateSilenceFillerUtterances): unknown {
    const obj: any = {};
    if (message.silenceFillerUtterances !== undefined) {
      obj.silenceFillerUtterances = FillerUtterances.toJSON(message.silenceFillerUtterances);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateSilenceFillerUtterances>): VoiceChannelUpdateSilenceFillerUtterances {
    return VoiceChannelUpdateSilenceFillerUtterances.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<VoiceChannelUpdateSilenceFillerUtterances>,
  ): VoiceChannelUpdateSilenceFillerUtterances {
    const message = createBaseVoiceChannelUpdateSilenceFillerUtterances();
    message.silenceFillerUtterances =
      (object.silenceFillerUtterances !== undefined && object.silenceFillerUtterances !== null)
        ? FillerUtterances.fromPartial(object.silenceFillerUtterances)
        : undefined;
    return message;
  },
};

function createBaseVoiceChannelResetSilenceFillerUtterances(): VoiceChannelResetSilenceFillerUtterances {
  return {};
}

export const VoiceChannelResetSilenceFillerUtterances: MessageFns<VoiceChannelResetSilenceFillerUtterances> = {
  encode(_: VoiceChannelResetSilenceFillerUtterances, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelResetSilenceFillerUtterances {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelResetSilenceFillerUtterances();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VoiceChannelResetSilenceFillerUtterances {
    return {};
  },

  toJSON(_: VoiceChannelResetSilenceFillerUtterances): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelResetSilenceFillerUtterances>): VoiceChannelResetSilenceFillerUtterances {
    return VoiceChannelResetSilenceFillerUtterances.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<VoiceChannelResetSilenceFillerUtterances>): VoiceChannelResetSilenceFillerUtterances {
    const message = createBaseVoiceChannelResetSilenceFillerUtterances();
    return message;
  },
};

function createBaseVoiceChannelUpdateAsrConfig(): VoiceChannelUpdateAsrConfig {
  return { asrConfig: undefined };
}

export const VoiceChannelUpdateAsrConfig: MessageFns<VoiceChannelUpdateAsrConfig> = {
  encode(message: VoiceChannelUpdateAsrConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asrConfig !== undefined) {
      Asr.encode(message.asrConfig, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateAsrConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateAsrConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.asrConfig = Asr.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateAsrConfig {
    return {
      asrConfig: isSet(object.asrConfig)
        ? Asr.fromJSON(object.asrConfig)
        : isSet(object.asr_config)
        ? Asr.fromJSON(object.asr_config)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateAsrConfig): unknown {
    const obj: any = {};
    if (message.asrConfig !== undefined) {
      obj.asrConfig = Asr.toJSON(message.asrConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateAsrConfig>): VoiceChannelUpdateAsrConfig {
    return VoiceChannelUpdateAsrConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateAsrConfig>): VoiceChannelUpdateAsrConfig {
    const message = createBaseVoiceChannelUpdateAsrConfig();
    message.asrConfig = (object.asrConfig !== undefined && object.asrConfig !== null)
      ? Asr.fromPartial(object.asrConfig)
      : undefined;
    return message;
  },
};

function createBaseVoiceChannelResetAsrConfig(): VoiceChannelResetAsrConfig {
  return {};
}

export const VoiceChannelResetAsrConfig: MessageFns<VoiceChannelResetAsrConfig> = {
  encode(_: VoiceChannelResetAsrConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelResetAsrConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelResetAsrConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VoiceChannelResetAsrConfig {
    return {};
  },

  toJSON(_: VoiceChannelResetAsrConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelResetAsrConfig>): VoiceChannelResetAsrConfig {
    return VoiceChannelResetAsrConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<VoiceChannelResetAsrConfig>): VoiceChannelResetAsrConfig {
    const message = createBaseVoiceChannelResetAsrConfig();
    return message;
  },
};

function createBaseVoiceChannelUpdateBargeInConfig(): VoiceChannelUpdateBargeInConfig {
  return {
    enabled: undefined,
    allowedFirstTurn: undefined,
    maxPerCall: undefined,
    minSpeechDurationSeconds: undefined,
  };
}

export const VoiceChannelUpdateBargeInConfig: MessageFns<VoiceChannelUpdateBargeInConfig> = {
  encode(message: VoiceChannelUpdateBargeInConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== undefined) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.allowedFirstTurn !== undefined) {
      writer.uint32(16).bool(message.allowedFirstTurn);
    }
    if (message.maxPerCall !== undefined) {
      writer.uint32(24).int32(message.maxPerCall);
    }
    if (message.minSpeechDurationSeconds !== undefined) {
      writer.uint32(33).double(message.minSpeechDurationSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateBargeInConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateBargeInConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.allowedFirstTurn = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxPerCall = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.minSpeechDurationSeconds = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateBargeInConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      allowedFirstTurn: isSet(object.allowedFirstTurn)
        ? globalThis.Boolean(object.allowedFirstTurn)
        : isSet(object.allowed_first_turn)
        ? globalThis.Boolean(object.allowed_first_turn)
        : undefined,
      maxPerCall: isSet(object.maxPerCall)
        ? globalThis.Number(object.maxPerCall)
        : isSet(object.max_per_call)
        ? globalThis.Number(object.max_per_call)
        : undefined,
      minSpeechDurationSeconds: isSet(object.minSpeechDurationSeconds)
        ? globalThis.Number(object.minSpeechDurationSeconds)
        : isSet(object.min_speech_duration_seconds)
        ? globalThis.Number(object.min_speech_duration_seconds)
        : undefined,
    };
  },

  toJSON(message: VoiceChannelUpdateBargeInConfig): unknown {
    const obj: any = {};
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.allowedFirstTurn !== undefined) {
      obj.allowedFirstTurn = message.allowedFirstTurn;
    }
    if (message.maxPerCall !== undefined) {
      obj.maxPerCall = Math.round(message.maxPerCall);
    }
    if (message.minSpeechDurationSeconds !== undefined) {
      obj.minSpeechDurationSeconds = message.minSpeechDurationSeconds;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateBargeInConfig>): VoiceChannelUpdateBargeInConfig {
    return VoiceChannelUpdateBargeInConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateBargeInConfig>): VoiceChannelUpdateBargeInConfig {
    const message = createBaseVoiceChannelUpdateBargeInConfig();
    message.enabled = object.enabled ?? undefined;
    message.allowedFirstTurn = object.allowedFirstTurn ?? undefined;
    message.maxPerCall = object.maxPerCall ?? undefined;
    message.minSpeechDurationSeconds = object.minSpeechDurationSeconds ?? undefined;
    return message;
  },
};

function createBaseVoiceChannelResetBargeInConfig(): VoiceChannelResetBargeInConfig {
  return {};
}

export const VoiceChannelResetBargeInConfig: MessageFns<VoiceChannelResetBargeInConfig> = {
  encode(_: VoiceChannelResetBargeInConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelResetBargeInConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelResetBargeInConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VoiceChannelResetBargeInConfig {
    return {};
  },

  toJSON(_: VoiceChannelResetBargeInConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelResetBargeInConfig>): VoiceChannelResetBargeInConfig {
    return VoiceChannelResetBargeInConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<VoiceChannelResetBargeInConfig>): VoiceChannelResetBargeInConfig {
    const message = createBaseVoiceChannelResetBargeInConfig();
    return message;
  },
};

function createBaseVoiceChannelUpdateTemperature(): VoiceChannelUpdateTemperature {
  return { temperature: undefined };
}

export const VoiceChannelUpdateTemperature: MessageFns<VoiceChannelUpdateTemperature> = {
  encode(message: VoiceChannelUpdateTemperature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.temperature !== undefined) {
      writer.uint32(13).float(message.temperature);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelUpdateTemperature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelUpdateTemperature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceChannelUpdateTemperature {
    return { temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : undefined };
  },

  toJSON(message: VoiceChannelUpdateTemperature): unknown {
    const obj: any = {};
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelUpdateTemperature>): VoiceChannelUpdateTemperature {
    return VoiceChannelUpdateTemperature.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceChannelUpdateTemperature>): VoiceChannelUpdateTemperature {
    const message = createBaseVoiceChannelUpdateTemperature();
    message.temperature = object.temperature ?? undefined;
    return message;
  },
};

function createBaseVoiceChannelResetTemperature(): VoiceChannelResetTemperature {
  return {};
}

export const VoiceChannelResetTemperature: MessageFns<VoiceChannelResetTemperature> = {
  encode(_: VoiceChannelResetTemperature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceChannelResetTemperature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceChannelResetTemperature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VoiceChannelResetTemperature {
    return {};
  },

  toJSON(_: VoiceChannelResetTemperature): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<VoiceChannelResetTemperature>): VoiceChannelResetTemperature {
    return VoiceChannelResetTemperature.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<VoiceChannelResetTemperature>): VoiceChannelResetTemperature {
    const message = createBaseVoiceChannelResetTemperature();
    return message;
  },
};

function createBaseWebChatChannelUpdateStatus(): WebChatChannelUpdateStatus {
  return { status: 0 };
}

export const WebChatChannelUpdateStatus: MessageFns<WebChatChannelUpdateStatus> = {
  encode(message: WebChatChannelUpdateStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebChatChannelUpdateStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebChatChannelUpdateStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebChatChannelUpdateStatus {
    return { status: isSet(object.status) ? channelStatusFromJSON(object.status) : 0 };
  },

  toJSON(message: WebChatChannelUpdateStatus): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = channelStatusToJSON(message.status);
    }
    return obj;
  },

  create(base?: DeepPartial<WebChatChannelUpdateStatus>): WebChatChannelUpdateStatus {
    return WebChatChannelUpdateStatus.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WebChatChannelUpdateStatus>): WebChatChannelUpdateStatus {
    const message = createBaseWebChatChannelUpdateStatus();
    message.status = object.status ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
